module.exports = __webpack_public_path__ + "static/media/modal_title2.e759f2be.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/modal_title2.png
// module id = 1497
// module chunks = 0